import { useEffect, useRef, useState } from 'react'

/** Column picker (decision 30) — every table gets one. */
export function FieldsPicker<K extends string>({
  fields, visible, onChange,
}: {
  fields: Array<{ key: K; label: string; locked?: boolean }>
  visible: Set<K>
  onChange: (next: Set<K>) => void
}) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!open) return
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [open])

  const toggle = (key: K) => {
    const next = new Set(visible)
    if (next.has(key)) next.delete(key)
    else next.add(key)
    onChange(next)
  }

  return (
    <div className="fields" ref={ref}>
      <button className="btn" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        Fields ({visible.size})
      </button>
      {open && (
        <div className="fields__menu">
          {fields.map((f) => (
            <label key={f.key} className="fields__row">
              <input
                type="checkbox"
                checked={visible.has(f.key)}
                disabled={f.locked}
                onChange={() => toggle(f.key)}
              />
              {f.label}
              {f.locked && <span className="muted small">(always)</span>}
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
